/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar27 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar27", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M14.09,21.543H8.733 v-1.196l2.227-2.095c1.035-0.957,1.299-1.313,1.299-1.729c0-0.518-0.381-0.864-0.962-0.864c-0.605,0-1.025,0.41-1.025,0.991v0.034 H8.631v-0.029c0-1.401,1.094-2.349,2.729-2.349c1.577,0,2.632,0.845,2.632,2.09c0,0.781-0.459,1.475-1.709,2.588l-1.162,1.069v0.093 h2.969V21.543z M21.408,15.879l-2.842,5.664h-1.875l2.925-5.571v-0.098h-3.413v-1.382h5.205V15.879z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar27.defaultProps = {
  className: null
};

IconCalendar27.propTypes = {
  className: PropTypes.string
};

export default IconCalendar27;
